<template>
  <div class="langganan-kunci" role="dialog" aria-modal="true" aria-labelledby="kunci-judul">
    <div class="kartu">
      <img class="kodok" src="/brand/kodok-sabar.svg" alt="" width="240" height="184" />
      <h1 id="kunci-judul" class="kunci-judul">Masa langganan berakhir</h1>
      <p class="utama">
        Masa langganan AccuTrax<span v-if="perusahaan"> untuk <strong>{{ perusahaan }}</strong></span>
        <template v-if="tanggal"> berakhir pada <strong>{{ tanggal }}</strong></template>.
        Aplikasi terkunci sampai perpanjangan dibayar.
      </p>
      <ul class="poin">
        <li><i class="fa-solid fa-shield-halved" aria-hidden="true"></i>Data Anda aman. Penjualan, stok dan laporan tetap tersimpan.</li>
        <li><i class="fa-solid fa-clock" aria-hidden="true"></i>Begitu pembayaran ditandai lunas, aplikasi terbuka sendiri dalam paling lama 10 menit.</li>
      </ul>
      <p v-if="pesan" class="pesan" role="status">{{ pesan }}</p>
      <div class="tombol">
        <button ref="periksa" type="button" class="btn utama-btn" :disabled="memeriksa" @click="periksa">
          {{ memeriksa ? "Memeriksa…" : "Periksa lagi" }}
        </button>
        <a class="btn" :href="portal" target="_blank" rel="noopener">Hubungi AccuTrax</a>
        <button type="button" class="btn teks" @click="$emit('keluar')">Keluar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/app-store";
import { tanggalPanjang, PORTAL_DUKUNGAN } from "@/helper/langganan";

export default {
  name: "LanggananKunci",
  emits: ["keluar"],
  data() {
    return { memeriksa: false, pesan: "", portal: PORTAL_DUKUNGAN };
  },
  computed: {
    store() {
      return useAppStore();
    },
    tanggal() {
      const b = this.store.langganan?.berakhir;
      return b ? tanggalPanjang(b) : "";
    },
    perusahaan() {
      return this.store.setting?.perusahaan?.nama || "";
    },
  },
  methods: {
    async periksa() {
      this.memeriksa = true;
      this.pesan = "";
      await this.store.loadLangganan();
      this.memeriksa = false;
      if (this.store.langganan?.habis !== false) {
        this.pesan = "Belum diperpanjang. Coba lagi beberapa menit setelah pembayaran ditandai lunas.";
        return;
      }
      // Sudah diperpanjang: muat ulang supaya setiap layar mengambil datanya lagi.
      window.location.reload();
    },
  },
  mounted() {
    this.$refs.periksa?.focus();
  },
};
</script>

<style scoped>
.langganan-kunci {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: grid;
  place-items: center;
  padding: 24px 16px;
  overflow-y: auto;
  background: var(--ground);
  animation: masuk 220ms var(--ease-out) both;
}
.kartu {
  width: min(520px, 100%);
  padding: 28px 32px 32px;
  border-radius: 16px;
  background: var(--surface);
  border: 1px solid var(--line);
  box-shadow: 0 18px 48px -18px rgba(14, 110, 110, 0.35);
  color: var(--text);
  text-align: center;
}
.kodok {
  width: 220px;
  height: auto;
  display: block;
  margin: 0 auto 8px;
}
.langganan-kunci .kartu .kunci-judul {
  margin: 0 0 10px;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.25;
  letter-spacing: -0.015em;
  color: var(--brand-ink);
  text-wrap: balance;
}
.dx-swatch-dark .langganan-kunci .kartu .kunci-judul {
  color: var(--text);
}
.utama {
  margin: 0 auto 18px;
  max-width: 44ch;
  line-height: 1.55;
}
.poin {
  list-style: none;
  margin: 0 0 20px;
  padding: 14px 16px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--brand-paper) 70%, var(--surface));
  text-align: left;
  display: grid;
  gap: 10px;
  line-height: 1.45;
}
.dx-swatch-dark .poin {
  background: color-mix(in srgb, var(--brand-ink) 22%, var(--surface));
}
.poin i {
  width: 18px;
  margin-right: 10px;
  color: var(--brand-ink);
}
.dx-swatch-dark .poin i {
  color: var(--brand-leaf);
}
.poin li {
  display: flex;
  align-items: baseline;
}
.pesan {
  margin: 0 0 14px;
  color: var(--danger-ink);
  font-weight: 600;
}
.tombol {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--text);
  font: 600 14px/1 var(--font-ui);
  text-decoration: none;
  cursor: pointer;
  transition: transform 140ms var(--ease-out), background-color 140ms ease;
}
.btn:active {
  transform: scale(0.97);
}
.btn:disabled {
  opacity: 0.7;
  cursor: progress;
}
.utama-btn {
  background: var(--brand-sun);
  border-color: transparent;
  color: var(--brand-sun-ink);
}
@media (hover: hover) and (pointer: fine) {
  .utama-btn:hover {
    background: var(--brand-sun-hover);
  }
  .btn:not(.utama-btn):hover {
    background: color-mix(in srgb, var(--brand-paper) 60%, var(--surface));
  }
}
.teks {
  border-color: transparent;
  background: transparent;
  color: var(--text-muted);
}
@keyframes masuk {
  from {
    opacity: 0;
    transform: scale(0.985);
  }
}
@media (prefers-reduced-motion: reduce) {
  .langganan-kunci {
    animation: pudar 160ms ease both;
  }
  .btn:active {
    transform: none;
  }
}
@keyframes pudar {
  from {
    opacity: 0;
  }
}
@media (max-width: 520px) {
  .kartu {
    padding: 20px 18px 24px;
  }
  .kodok {
    width: 170px;
  }
}
</style>
